import { useMemo } from 'react';

import { type UseFanTokenBreakdownCardSummaryProps } from '../../models';

const MAX_TOKENS = 5;

export const useFanTokenBreakdownCardSummary = ({
	AmountIndicator,
	TeamLogo,
	tokens: tokensProp
}: UseFanTokenBreakdownCardSummaryProps) => {
	const tokens = useMemo(() => {
		const tokens = tokensProp.map(token => {
			return (
				<TeamLogo
					key={token.shortCode}
					logo={token.logo}
					name={token.name}
					shortCode={token.shortCode}
					size={22}
				/>
			);
		});

		if (tokens.length > MAX_TOKENS) {
			const extra = `+${tokens.length - MAX_TOKENS + 1}`;

			tokens.splice(MAX_TOKENS - 1);

			tokens.push(<AmountIndicator key="extra-amount-indicator">{extra}</AmountIndicator>);
		}

		return tokens;
	}, [tokensProp]);

	return { tokens };
};
